import DepositIcon from "@/components/icons/deposit-icon";
import WithdrawIcon from "@/components/icons/withdraw-icon";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import TopupCountdown from "@/components/topup-countdown";

const SuccessNotice = ({
  type,
  topupMeta,
  closeModal,
}: {
  type:
    | "withdrawal"
    | "deposit"
    | "card-topup"
    | "card-withdrawal"
    | "add-contact"
    | "register"
    | "statement"
    | "internal-transfer";
  topupMeta?: { createdAt: string; amount: number; currency?: string };
  closeModal: () => void;
}) => {
  if (type === "internal-transfer")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div className="border-dark-primary-main bg-dark-primary-50 flex size-16 items-center justify-center rounded-full border">
          <Check className="text-dark-primary-400" strokeWidth={2.5} />
        </div>
        <div className="mt-2 text-2xl font-medium">Transfer successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Done
          </Button>
        </div>
      </div>
    );

  if (type === "statement")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div className="border-dark-primary-main bg-dark-primary-50 flex size-16 items-center justify-center rounded-full border">
          <Check className="text-dark-primary-400" strokeWidth={2.5} />
        </div>
        <div className="mt-2 text-2xl font-medium">Statement downloaded</div>
        <p className="text-dark-text-300 -mt-2 max-w-[80%] text-center text-xs font-light">
          Check your downloads for the PDF file.
        </p>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Done
          </Button>
        </div>
      </div>
    );

  if (type === "deposit")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <DepositIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Deposit successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-400 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <WithdrawIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Withdrawal successful</div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-400 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "card-topup")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <DepositIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">Card Top Up Processing</div>
        {topupMeta?.createdAt && (
          <div className="w-full">
            <TopupCountdown
              createdAt={topupMeta.createdAt}
              amount={topupMeta.amount}
              currency={topupMeta.currency}
            />
          </div>
        )}
        <div className="mt-2 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Continue
          </Button>
        </div>
      </div>
    );

  if (type === "card-withdrawal")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div className="border-primary-100 flex size-16 items-center justify-center rounded-full border">
          <WithdrawIcon className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Card Withdrawal successful
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Continue
          </Button>
          <Button
            onClick={closeModal}
            className="border-dark-primary-main hover:bg-dark-primary-100 text-dark-text-400 h-11 grow border bg-transparent"
          >
            See Details
          </Button>
        </div>
      </div>
    );

  if (type === "add-contact")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div
          className="border-primary-100 flex size-16 items-center justify-center rounded-full border"
          style={{
            background:
              "linear-gradient(100.47deg, #5778C766 9.36%, #545A9366 100%)",
          }}
        >
          <Check className="text-primary-100" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Contact added successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={closeModal}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Close
          </Button>
        </div>
      </div>
    );

  if (type === "register")
    return (
      <div className="my-4 flex w-full flex-col items-center gap-4">
        <div className="border-dark-primary-main bg-dark-primary-50 flex size-16 items-center justify-center rounded-full border">
          <Check className="text-dark-primary-main" />
        </div>
        <div className="mt-2 text-2xl font-medium">
          Account created successfully
        </div>
        <div className="mt-4 flex w-full items-center gap-2">
          <Button
            onClick={() => (window.location.href = "/login")}
            className="text-dark-text-400 bg-dark-primary-main hover:bg-dark-primary-100 h-11 grow"
          >
            Continue to Login
          </Button>
        </div>
      </div>
    );
};

export default SuccessNotice;
